import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, filter, take, switchMap, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { AuthSelectors } from '@/app/+state/auth';
import { selectIsLoggedIn } from '@/app/+state/auth/auth.selectors';

export const authGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(AuthSelectors.selectAuthInitialized).pipe(
        filter((initialized) => initialized),
        take(1),
        switchMap(() =>
            combineLatest([
                store.select(selectIsLoggedIn),
                store.select(AuthSelectors.selectUser),
                store.select(AuthSelectors.selectAuthState),
            ]),
        ),
        take(1),
        map(([isLoggedIn]) => {
            if (isLoggedIn) {
                return true;
            }
            return router.createUrlTree(['/auth/login']);
        }),
    );
};
